import { getRestrictions } from '@wix/ambassador-forms-v4-restrictions/http';
import type { ErrorHandlerPublicAPI } from '@wix/fe-essentials-editor/error-handler';
import { withCancelToken } from '@wix/form-http-essentials';
import { type IHttpClient } from '@wix/yoshi-flow-editor';

export const isFormsLimitReached = async ({
  httpClient,
  errorHandler,
  signal,
}: {
  httpClient: IHttpClient;
  errorHandler: ErrorHandlerPublicAPI;
  signal?: AbortSignal;
}) => {
  const { withErrorHandler, getResolvedError } = errorHandler;

  try {
    const restrictionsResponse = await withErrorHandler(
      () =>
        httpClient
          .request(withCancelToken(getRestrictions({}), signal, httpClient))
          .then((res) => res.data),
      { errorCodesMap: {} },
    );
    const formsLimit = restrictionsResponse.restrictions?.formsLimit?.limit;
    const totalActiveFormCount = restrictionsResponse.totalFormCount;

    if (
      formsLimit === undefined ||
      formsLimit === null ||
      totalActiveFormCount === undefined
    ) {
      return;
    }

    return formsLimit !== -1 && formsLimit <= totalActiveFormCount;
  } catch (e) {
    const resolvedError = getResolvedError(e);
    console.error(resolvedError);
    throw new Error('Failed to fetch restrictions');
  }
};
